// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0ec825e9","455":"1a7edb53","977":"aeb22268"}[chunkId] + ".chunk.js";
};